import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenService } from '../services/token.service';
import { CoreService } from '../services/core.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService, 
    private settings: CoreService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const isPharmaRequest = req.url.includes(environment.pharmaKgb);
    if (isPharmaRequest) {
      return next.handle(req);
    }
    return this.tokenService.initToken().pipe(
      switchMap(() => {
        const token = this.tokenService.getToken();
        if (token) {
          const clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              'Portal-Type': this.settings.getPortalType()
            },
          });
          return next.handle(clonedRequest);
        }
        return next.handle(req);
      }),
      catchError((err) => {
        console.error('Errore nel TokenInterceptor:', err);
        return next.handle(req);
      })
    );
  }
}
